import api from './api';

const partnerSyncTemplatesService = {
    list: (partnerId) =>
        api.get(`/partnersynctemplates?partnerId=${partnerId}`).then(r => r.data),

    get: (id) =>
        api.get(`/partnersynctemplates/${id}`).then(r => r.data),

    create: (partnerId, syncTemplateId, name) =>
        api.post('/partnersynctemplates', { partnerId, syncTemplateId, name }).then(r => r.data),

    update: (id, name) =>
        api.put(`/partnersynctemplates/${id}`, { name }).then(r => r.data),

    remove: (id) =>
        api.delete(`/partnersynctemplates/${id}`).then(r => r.data),

    getTasks: (id) =>
        api.get(`/partnersynctemplates/${id}/tasks`).then(r => r.data),

    setDefault: (id) =>
        api.post(`/partnersynctemplates/${id}/set-default`).then(r => r.data),

    resolve: (partnerId, hotelId, syncTemplateId) =>
        api.get(`/partnersynctemplates?action=resolve&partnerId=${partnerId}&hotelId=${hotelId}&syncTemplateId=${syncTemplateId}`).then(r => r.data),

    listShares: (id) =>
        api.get(`/partnersynctemplates/${id}/shares`).then(r => r.data),

    addShare: (id, accountId, hotelId) =>
        api.post(`/partnersynctemplates/${id}/shares`, { accountId, hotelId }).then(r => r.data),

    removeShare: (id, shareId) =>
        api.delete(`/partnersynctemplates/${id}/shares/${shareId}`).then(r => r.data),

    addExclusion: (id, taskId) =>
        api.post(`/partnersynctemplates/${id}/tasks/${taskId}/exclude`).then(r => r.data),

    removeExclusion: (id, taskId) =>
        api.delete(`/partnersynctemplates/${id}/tasks/${taskId}/exclude`).then(r => r.data),
};

export default partnerSyncTemplatesService;
